<template>
  <b-container fluid v-if="period_context_loaded">
    <b-row class="text-base mb-2 pl-2">
      Pedidos despachados e gastos com frete:
    </b-row>

    <b-row>
      <b-col v-for="(obj, i) in ShippingsCardsObject" :key="'obj-' + i" lg="3" md="6" sm="12">
        <shipping-card class="pr-2 pb-4 pl-2" :info="obj.info" :title="obj.title">
          <div slot="image" :class="obj.bg + ' img-box'">
            <img :src="require(`@/assets/${obj.img}`)" alt="img">
          </div>
        </shipping-card>
      </b-col>
    </b-row>
  </b-container>
  <loader-box v-else height="90px" class="mr-2 mb-4 ml-2"/>
</template>

<script>
import ShippingCard from './ComponentShippingCard.vue'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    ShippingCard,
    LoaderBox
  },
  computed: {
    period_context_loaded() { return this.$store.getters.period_context_loaded },
    ShippingsCardsObject() { return this.$store.getters.ShippingsCardsObject }
  }
}
</script>

<style>

</style>
